<div [class.validation]="reason<0">
    <fieldset [disabled]="controlDisabled">
        <div>
            <label class="radio-alignment">
                <input type="radio"
                       [(ngModel)]="reason"
                       name="reason_{{id}}"
                       [value]="0"
                       (click)="setNoneWorkPlan()"/>
                None
            </label>
        </div>

        <div>
            <label class="radio-alignment">
                <input type="radio"
                       [(ngModel)]="reason"
                       name="reason_{{id}}"
                       [value]="1"
                       (click)="resetWorkPlan(1, reason)"/>
                Over
            </label>
        </div>
        <div>
            <label class="radio-alignment">
                <input type="radio"
                       [(ngModel)]="reason"
                       name="reason_{{id}}"
                       [value]="2"
                       (click)="resetWorkPlan(2, reason)"/>
                Under
            </label>
        </div>
    </fieldset>

    <div *ngIf="reason > 0">
        <p>Activity ran
            <span>
                <b class="main-color" *ngIf="reason == 1">over</b>
                <b class="main-color" *ngIf="reason == 2">under</b>
            </span> due to</p>
        <button class="btn btn-primary"
                [disabled]="controlDisabled"
                (click)="reasonSelector.open()">{{ l('SelectReason') }}
        </button>

        <div *ngIf="reasonsFormCtrl && reasonsFormCtrl?.value"
             class="mt-3">
            <b>{{ reasonsFormCtrl.value.length }} {{ l('selected') }}</b>:
            <span *ngFor="let reason of reasonsFormCtrl.value; last as isLast">
                {{ reason.varianceFromPlanReason ? reason.varianceFromPlanReason.name : reason.name }} {{ !isLast ? ',' : null }}
            </span>
        </div>
    </div>

    <div style="opacity: 0; pointer-events: none; height: 0px;">
        <mat-form-field>
            <mat-select [formControl]="reasonsFormCtrl"
                        [multiple]="true"
                        #reasonSelector>
                <mat-option>
                    <ngx-mat-select-search
                        noEntriesFoundLabel="No results found"
                        placeholderLabel="Find a reason..."
                        [formControl]="reasonsFilterFormCtrl">
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let reason of filteredReasons | async"
                            [value]="reason"
                            (click)="saveSelectedReasons()">
                    {{ reason.varianceFromPlanReason.name  }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="validation text-size" *ngIf="reason<0">{{ l('SelectVarianceFromPlan') }}</div>
</div>

